import * as React from 'react'
import { useMonth, FirstDayOfWeek } from '@datepicker-react/hooks'
import * as styles from '../../date.pickers.styl'
import { DayOptions } from '../../models'
import { WeekdayLabels } from './weekday.labels'
import { Weekdays } from './week.days'

export interface MonthProps {
  year: number
  month: number
  firstDayOfWeek: FirstDayOfWeek
}

const Month: React.FC<MonthProps> = ({
  year,
  month,
  firstDayOfWeek
}: MonthProps) => {
  const { days, weekdayLabels, monthLabel } = useMonth({
    year,
    month,
    firstDayOfWeek
  })

  return (
    <div className={styles.month} role="month-wrapper">
      <div role="month-label" className={styles.header}>
        {monthLabel}
      </div>
      <WeekdayLabels labels={weekdayLabels} />
      <Weekdays month={month} days={days as DayOptions[]} />
    </div>
  )
}

export default Month
